import React from 'react';
import { Link } from 'react-router-dom';

const formatToIDR = (amount) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
  }).format(amount);
};

const Product = ({ id, name, image, price }) => {
  return (
    <div className="product-card">
      <img src={image} alt={name} />
      <div className="product-info">
        <h3 className="product-title">{name}</h3>
        <p className="product-price">{formatToIDR(price)}</p>
        <p className="product-striked-price">{formatToIDR(price * 1.2)}</p>
        <Link to={`/product/${id}`} className="btn center-link">View Details</Link>
      </div>
    </div>
  );
};

export default Product;